import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import "./research-hub-section.m.css";
import Chevron from "../../../../assets/icons/chevron";

const ResearchHubSection = () => {
  const cdnHost = useSelector((state) => get(state, ["qt", "config", "cdn-image"]));
  const researchBannerKey = useSelector((state) => get(state, ["qt", "config", "publisher-attributes","homePageData","researchHubImageKey"], {}));
  const researchBanner = `https://${cdnHost}/${researchBannerKey}`;
  const researchCategories = [
    {
      title: "Economic & Policy Updates",
      description: "Regular assessments that help leaders anticipate change"
    },
    {
      title: "Sector Insights",
      description: "Trends that explain market movements before they appear in headlines."
    },
    {
      title: "Opinion Pieces",
      description: "Independent thinking on India's business and policy landscape"
    }
  ];

  return (
    <div styleName="research-hub-section">
      <div styleName="container">
        <div styleName="header">
          <div styleName="shoulder-tag">
            Research and business intelligence
          </div>
          <h2 styleName="section-heading">
            Cutting through the noise
          </h2>
        </div>

        <div styleName="hero-image">
          <img
            src={researchBanner}
            alt="Research Hub"
            styleName="banner-image"
          />
        </div>

        <div styleName="content">
          <div styleName="categories-grid">
            {researchCategories.map((category, index) => (
              <div key={index} styleName="category-item">
                <h3 styleName="category-title">{category.title}</h3>
                <p styleName="category-description">{category.description}</p>
              </div>
            ))}
          </div>

          {/* <div styleName="link-container">
            <a href="/collection/research-hub" styleName="explore-link">
              <span styleName="link-text">Explore research hub</span>
              <div styleName="chevron-icon"><Chevron color="#242424" /></div>
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export { ResearchHubSection };